import { getSessionId } from "../../authStorage";

export default () => `lobby:${getSessionId()}`;
